<template>
  <vjs-modal name="delete-stream-modal"
             icon="la la-trash"
             title="Delete Stream">
    <template slot="body-content">
      <div class="form-group kt-form__group tags-select">
        <label for="name">Please enter the name of the stream you want to delete...</label>
        <input id="name"
               v-model="name" class="form-control"
               type="text">
        <div class="warning">
          Warning: All associated
          streams will be removed. This action cannot be
          undone.
        </div>
      </div>
    </template>
    <template slot="body-controls">
      <button class="btn btn-ss-danger"
              @click="destroy">
        <span>
          <i class="la la-trash" />
          <span>Delete Stream</span>
        </span>
      </button>
      <button type="button" class="btn btn-ss-cancel"
              @click="closeModal">
        Cancel
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from "VueModals/VjsModal";

export default {
  components: {
    VjsModal,
  },
  data: () => ({
    name: "",
  }),
  methods: {
    destroy() {
      this.$emit('input', this.name);
      this.name = "";
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide(`delete-stream-modal`);
    },
  },
};
</script>

<style lang='scss'>
.warning {
    color: red;
    margin-top: 10px;
}
</style>
